module.exports = __webpack_public_path__ + "static/img/toujiao77.31426b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/toujiao77.jpg
// module id = A/tH
// module chunks = 1